import cloneDeep from 'lodash.clonedeep';
import ChangeProduct from './ChangeCover/ChangeProduct';
import CaptureAdditionalInformation from './ChangeCover/CaptureAdditionalInformation';

const initialState = {
  referenceData: null,
  memberDetails: [],
  membershipPolicy: null,
  eligibilityDetails: null,
  membershipProducts: null,
  currentComposition: null,
  currentExcess: null,
  currentRebateTier: null,
  currentMyCircumstances: null,
  currentNumberOfChildren: null,
  currentState: null,
  currentEligibility: null,
  currentPremium: null,
  currentCoverStartDate: null,
  policyHolderProductHistory: null,
  partnerProductHistory: null,
  memberPolicies: null,
  submitPolicyInProcess: false,
};

export default {
  namespaced: true,

  state: { ...initialState },

  mutations: {
    updateReferenceData(state, data) {
      state.referenceData = data;
    },

    updateMemberDetails(state, data) {
      state.memberDetails = data;
    },

    updateMembershipPolicy(state, data) {
      state.membershipPolicy = data;
    },

    updateEligibilityDetails(state, data) {
      state.eligibilityDetails = data;
    },

    updateMembershipProducts(state, data) {
      state.membershipProducts = data;
    },

    updateCurrentComposition(state, data) {
      state.currentComposition = data;
    },

    updateCurrentChildren(state, data) {
      state.currentNumberOfChildren = data;
    },

    updateCurrentRebateTier(state, data) {
      state.currentRebateTier = data;
    },

    updateCurrentMyCircumstances(state, data) {
      state.currentMyCircumstances = data;
    },

    updateCurrentExcess(state, data) {
      state.currentExcess = data;
    },

    updateCurrentState(state, data) {
      state.currentState = data;
    },

    updateCurrentEligibility(state, data) {
      state.currentEligibility = data;
    },

    updateCurrentPremium(state, data) {
      state.currentPremium = data;
    },

    updateCurrentCoverStartDate(state, data) {
      state.currentCoverStartDate = data;
    },

    updatePolicyHolderProductHistory(state, data) {
      state.policyHolderProductHistory = data;
    },

    updatePartnerProductHistory(state, data) {
      state.partnerProductHistory = data;
    },

    updateMemberPolicies(state, data) {
      state.memberPolicies = data;
    },

    resetData(state) {
      Object.assign(state, cloneDeep(initialState));
    },

    updateSubmitPolicyInProcess(state, data) {
      state.submitPolicyInProcess = data;
    },
  },

  getters: {
    getReferenceData: (state) => {
      return state.referenceData;
    },

    getMemberDetails: (state) => {
      return state.memberDetails;
    },

    getMembershipPolicy: (state) => {
      return state.membershipPolicy;
    },

    getEligibilityDetails: (state) => {
      return state.eligibilityDetails;
    },

    getMembershipProducts: (state) => {
      return state.membershipProducts;
    },

    getCurrentComposition: (state) => {
      return state.currentComposition;
    },

    getCurrentRebateTier: (state) => {
      return state.currentRebateTier;
    },

    getCurrentMyCircumstances: (state) => {
      return state.currentMyCircumstances;
    },

    getCurrentChildren: (state) => {
      return state.currentNumberOfChildren;
    },

    getCurrentExcess: (state) => {
      return state.currentExcess;
    },

    getCurrentState: (state) => {
      return state.currentState;
    },

    getCurrentEligibility: (state) => {
      return state.currentEligibility;
    },

    getCurrentPremium: (state) => {
      return state.currentPremium;
    },

    getCurrentCoverStartDate: (state) => {
      return state.currentCoverStartDate;
    },

    getPolicyHolderProductHistory: (state) => {
      return state.policyHolderProductHistory;
    },

    getPartnerProductHistory: (state) => {
      return state.partnerProductHistory;
    },

    getMemberPolicies: (state) => {
      return state.memberPolicies;
    },

    getSubmitPolicyInProcess: (state) => {
      return state.submitPolicyInProcess;
    },
  },

  modules: {
    ChangeProduct,
    CaptureAdditionalInformation,
  },
};
